import React from 'react';

import './BlogLayout.css';

const BlogLayout = ({ children, sidebar }) => {
  return (
    <div className='blog-layout-container'>
      <main className='blog-layout-content-container'>{children}</main>
      <aside className='blog-layout-sidebar-container'>{sidebar}</aside>
    </div>
  );
};

export default BlogLayout;
